import { useRef } from 'react';

/**
 * Captures `value` on the first render and returns that captured value for the
 * component's lifetime, ignoring later changes.
 *
 * Used for `default*` props, which follow React's uncontrolled convention: the
 * prop seeds the initial state and subsequent updates are ignored.
 *
 * Only the prop value is frozen, never a value derived from it, so a
 * percentage width still resolves against the live container on every render.
 *
 * @internal
 */
export function useMountValue<T>(value: T): T {
  const ref = useRef<T>(value);
  return ref.current;
}
